import React from 'react'
import { Link } from 'react-router-dom'

import "./Layout.scss"
import logoImg from "../../assets/images/logo.svg"
import logoImg_mobile from "../../assets/images/whitelogo.svg"
// import fb_icon from "../../assets/images/facebook.svg"
// import insta_icon from "../../assets/images/instagram.svg"
// import twt_ion from "../../assets/images/twitter.svg"
// import yt_icon from "../../assets/images/youtube.svg"
// import fb_icon_dark from "../../assets/images/facebook_line.svg"
// import insta_icon_dark from "../../assets/images/instagram_line.svg"
// import twt_ion_dark from "../../assets/images/twitter_line.svg"
// import yt_icon_dark from "../../assets/images/youtube_line.svg"

const layout = ({ children }) => {
    const currentYear = new Date().getFullYear();
    return (
        <div className="layout mob_layout_bg">
            <div className="container-fluid" >
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-12 bg_gray  bg_mobile ">
                        <div className="bg_gray bg_mobile">
                            <div className="logoImg ">
                                <img className='desktop_content' src={logoImg} alt="black logo" width={205} height={104}/>
                                <img className='mob_display_inline mobile_content mobile_logo' src={logoImg_mobile} alt="white logo" width={85} height={55}/>
                            </div>
                            {children}
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-8 col-sm-8  banner_bg desktop_content">
                    </div>
                </div>
                <div className="social_media_row desktop_content">
                    <div className="row">
                        <div className="col-4 background_color_gray">
                            <p>  <span className="high_light_text">©{currentYear} DLF Malls Rewards </span>| All copyrights reserved</p>
                        </div>
                        <div className="col-8 background_color_Black">
                            <div className="row">
                                <div className="col-6 col-lg-9 col-md-8">
                                    <span><Link to="/terms-and-conditions">Terms & Conditions</Link></span>
                                    {/* <span>Returns & Refunds</span> */}
                                    <span><Link to="/privacy">Privacy Policy</Link></span>
                                </div>
                                {/* <div className="col">
                                    <span><img src={insta_icon} alt="" /></span>
                                    <span><img src={fb_icon} alt="" /></span>
                                    <span><img src={twt_ion} alt="" /></span>
                                    <span><img src={yt_icon} alt="" /></span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mob_social_media mobile_content">
                <div className="row">
                    {/* <div className="social_media_icon" style={{backgroundColor: "#F7F3EB", marginTop: "-1px"}}>
                        <span><img src={insta_icon_dark} alt="" /></span>
                        <span><img src={fb_icon_dark} alt="" /></span>
                        <span><img src={twt_ion_dark} alt="" /></span>
                        <span><img src={yt_icon_dark} alt="" /></span>
                    </div> */}
                    <div className="copyrigth">
                        <p><span className='high_light_text'>©{currentYear} DLF Malls Rewards </span> | All copyrights reserved</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default layout